import type { ReactNode } from 'react';
import React from 'react';
import { CopyButton } from '@gov-nx/ui/web';

export const Row = ({
	label,
	children,
	testId,
}: {
	label: string;
	testId?: string;
	children: ReactNode;
}) => (
	<tr>
		<td className="sm:w-1/2">{label}</td>
		<td className="sm:w-1/2">
			<strong data-testid={testId}>{children}</strong>
		</td>
	</tr>
);

export const CopyOrEmpty = ({
	value,
	label,
}: {
	value?: string | number;
	label: string;
}) => {
	if (!value) {
		return '-';
	}
	return (
		<>
			{value}
			<CopyButton
				value={value}
				label={label}
			/>
		</>
	);
};
